import { useContext, useEffect, useState } from "react";
import "../PPMContent/PPMContent.scss";
import "./CorporateGovernancePolicy.scss";
import "../SafeAggrement/SafeAggrement.scss";
import parser from "html-react-parser";
import { Context } from "../../contextApi/contextProvider";
import { cmsPublicContent } from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";

const PrivacyPolicy = () => {
  const loaction = useGeoLocation();
  const { userLoginData } = useContext(Context);
  const [htmlStr, setHtmlStr] = useState<any>([]);
  const contents = [
    "1. Introduction ",
    "2. Interpretation and Definitions",
    "3. Collecting and Using Your Personal Data ",
    "4. Information Collected while Using the Application ",
    "5. Tracking Technologies and Cookies ",
    "6. Use of Your Personal Data",
    "7. Disclosure of Personal Information ",
    "8. Transfer of Your Personal Data ",
    "9. Data Subject Rights",
    "10.Disclosure of Your Personal Data",
    "11.Security of Your Personal Data",
    "12.Children’s Privacy",
    "13.Changes to this Privacy Policy",
    "14.ADDITIONAL DISCLOSURES FOR INDIVIDUALS IN EUROPE",
    "15.Contact Us",
  ];

  const fetchCmsContent = async () => {
    const response = await cmsPublicContent({
      post_id: "7343",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    readDoc();
    fetchCmsContent();

    document.title = "TICCA | Privacy Policy";
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    readDoc();
  }, [userLoginData.status]);
  const readDoc = async () => {
    if (userLoginData.status === 200) {
      try {
        const { data } = await MarkDocumentRead({
          ip_address: await userLoginData.ip,
          latitude: loaction.coordinates?.lat ?? "0.0",
          longitude: loaction.coordinates?.lng ?? "0.0",
          post_id: "7343",
        });
      } catch (error) {}
    }
  };
  return (
    <>
      {htmlStr.length && (
        <div className="watermaring-main-dev">
          <img
            src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
            alt="logo"
          />
          <p>
            Commercial in Confidence <br />
            Content under NDA.
            <br /> {userLoginData?.email}
          </p>
        </div>
      )}
      {htmlStr.length <= 2 && (
        <div
          style={{ marginTop: "100px" }}
          className=" page-shimmer-container-co"
        >
          {Array.from({ length: 20 }).map((_, index) => (
            <div className="page-shimmer-co" key={index}></div>
          ))}
        </div>
      )}
      {htmlStr.length > 2 && (
        <div style={{ marginTop: "100px" }} className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <p className="cor-title">Privacy Policy</p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr.map((elem: any, index: number) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {parser(elem)}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default PrivacyPolicy;
